import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Privacy from "../Components/Privacy"
import "./Contact.css"; // Custom CSS

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  // Form Validation Schema
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().min(3, "At least 3 characters").required("Name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      message: Yup.string().min(10, "At least 10 characters").required("Message is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Submitted:", values);
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 3000);
    },
  });

  return (

    <>
     <div className="container-xxl py-5 hero-header1">
      <div className="container my-5 py-5 px-lg-5">
        <div className="row g-5 py-5">
          <div className="col-12 text-center">
            <h1 className="text-white animated slideInDown">Contact Us</h1>
            <hr className="bg-white mx-auto mt-0" style={{ width: "90px" }} />
          </div>
        </div>
      </div>
    </div>

    <Container className="contact-container py-5 mt-5 pt-5 mb-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <h2 className="text-center mb-4">Contact Us</h2>
          {submitted && <p className="alert alert-success text-center">Form submitted successfully!</p>}

          <Form onSubmit={formik.handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label></Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter your name"
                {...formik.getFieldProps("name")}
                className={formik.touched.name && formik.errors.name ? "is-invalid" : ""}
              />
              {formik.touched.name && formik.errors.name && <div className="invalid-feedback">{formik.errors.name}</div>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label></Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter your email"
                {...formik.getFieldProps("email")}
                className={formik.touched.email && formik.errors.email ? "is-invalid" : ""}
              />
              {formik.touched.email && formik.errors.email && <div className="invalid-feedback">{formik.errors.email}</div>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label></Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                placeholder="Write your message"
                {...formik.getFieldProps("message")}
                className={formik.touched.message && formik.errors.message ? "is-invalid" : ""}
              />
              {formik.touched.message && formik.errors.message && <div className="invalid-feedback">{formik.errors.message}</div>}
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100">
              Submit
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>

    <Privacy />
    </>
  );
};

export default Contact;
